import { render, staticRenderFns } from "./business_contry.vue?vue&type=template&id=6b80f4d4&scoped=true"
import script from "./business_contry.vue?vue&type=script&lang=js"
export * from "./business_contry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80f4d4",
  null
  
)

export default component.exports